/**
 * Progress bar computation utilities.
 *
 * Extracted from ProgressBar component to keep components presentational.
 */

interface ProgressState {
  sortedLevels: number[]
  maxLevel: number
  levelReached: number
  nextLevel: number
  percentage: number
  difference: string
  allLevelsReached: boolean
}

/**
 * Compute progress state from cart total and promotion levels.
 */
export function computeProgress(
  total: number,
  promotionLevels: readonly number[]
): ProgressState {
  const sortedLevels = [...promotionLevels].sort((a, b) => a - b)
  const maxLevelValue = sortedLevels[sortedLevels.length - 1] ?? 0

  let nextLevel = maxLevelValue
  let prevLevel = 0
  let levelReached = 0

  for (let i = 0; i < sortedLevels.length; i++) {
    if (total >= sortedLevels[i]) {
      levelReached = i + 1
      prevLevel = sortedLevels[i]
    } else {
      nextLevel = sortedLevels[i]
      break
    }
  }

  const range = nextLevel - prevLevel
  const percentage = range > 0 ? Math.min(((total - prevLevel) / range) * 100, 100) : 0
  const difference = Math.max(nextLevel - total, 0).toFixed(2)
  const maxLevel = sortedLevels.length
  const allLevelsReached = levelReached >= maxLevel

  return {
    sortedLevels,
    maxLevel,
    levelReached,
    nextLevel,
    percentage,
    difference,
    allLevelsReached,
  }
}
